import script from "./item-card.vue?vue&type=script&setup=true&lang=js"
export * from "./item-card.vue?vue&type=script&setup=true&lang=js"

import "./item-card.vue?vue&type=style&index=0&id=5f697fc2&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f697fc2"]])

export default __exports__